import React from "react";
import { useParams } from "react-router-dom";

const WalletPreview: React.FC = () => {
  const { param1, param2 } = useParams();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Wallet Pass Preview</h1>
        
        <div className="space-y-4">
          <div className="bg-gray-100 rounded-lg p-4">
            <p className="text-sm text-gray-600">Link Parameters</p>
            <p className="font-mono text-lg">{param1}/{param2}</p>
          </div>

          <div className="space-y-3">
            <a
              href={`/${param1}/${param2}?device=ios`}
              className="block w-full py-3 bg-black text-white rounded-lg text-center font-semibold hover:bg-gray-800 transition"
            >
              🍎 Add to Apple Wallet
            </a>
            
            <a
              href={`/${param1}/${param2}?device=android`}
              className="block w-full py-3 bg-blue-600 text-white rounded-lg text-center font-semibold hover:bg-blue-700 transition"
            >
              🔷 Add to Google Wallet
            </a>
          </div>

          <div className="pt-4 border-t">
            <p className="text-sm text-gray-500 text-center">
              This link will automatically detect your device and redirect to the appropriate wallet
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletPreview;